module.exports = "/templates/viewreport.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/viewreport.html
// module id = 485
// module chunks = 0